var bikeTyreSearch = (function ($) {

    function initialize() {
        $(".bike-hero .search-form-wrapper .search-popup-container").on("click", ".ftr-prod-link", function (e) {
            e.preventDefault();
            var searchInput = $("#fullTextSearchForm #fullTextSearch").val();
            window.location.href = $(this).attr("href") + "&trackingData=" + searchInput;
        });

        $(".bike-hero #fullTextSearchForm").on("submit", function (e) {
            var searchInput = $("#fullTextSearchForm #fullTextSearch").val();
            var input = $("<input>")
                .attr("type", "hidden")
                .attr("name", "trackingData").val(searchInput);
            $(this).append(input);
        });
    }

    return {
        initialize: initialize
    };
})($);

$(function () {
    bikeTyreSearch.initialize();
});